export const SANKEY_BEESWARM_MOCK_DATA: any[] = [
  {
    "du_patient_id": 10270144.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10270262.0,
    "level_1": "Amber",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10270266.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10270373.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10270374.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10270659.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10270660.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10270716.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10271237.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10271336.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10272218.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10272524.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10272716.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10273738.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10273889.0,
    "level_1": "Amber",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10274916.0,
    "level_1": "Onco360",
    "level_2": "Hub Engaged",
    "level_3": "Filled",
    "level_4": "Pap",
    "time": 7.0
  },
  {
    "du_patient_id": 10274919.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10274920.0,
    "level_1": "Emory Healthcare",
    "level_2": "Hub Engaged",
    "level_3": "Filled",
    "level_4": "Pap",
    "time": 9.0
  },
  {
    "du_patient_id": 10275238.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10275835.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10276074.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10276230.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10276232.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10276486.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10277252.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10277464.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10278430.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10278431.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10278588.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10278730.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10279197.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10279199.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10279496.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10279994.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10280922.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10281035.0,
    "level_1": "Biologics",
    "level_2": "Hub Engaged",
    "level_3": "Filled",
    "level_4": "Pap",
    "time": 14.0
  },
  {
    "du_patient_id": 10281120.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10281493.0,
    "level_1": "Biologics",
    "level_2": "Hub Engaged",
    "level_3": "Filled",
    "level_4": "Paid Claims",
    "time": 23.0
  },
  {
    "du_patient_id": 10281625.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10282292.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10282472.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10282473.0,
    "level_1": "Onco360",
    "level_2": "Hub Engaged",
    "level_3": "Filled",
    "level_4": "Paid Claims",
    "time": 18.0
  },
  {
    "du_patient_id": 10282946.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10282949.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10283229.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10283442.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284020.0,
    "level_1": "University Of California San Francisco",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284023.0,
    "level_1": "Uf Shands Gainesville",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284027.0,
    "level_1": "Baptist Memorial Health Care Corporation",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284029.0,
    "level_1": "Penn State",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284040.0,
    "level_1": "Kansas University",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284042.0,
    "level_1": "Kansas University",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284046.0,
    "level_1": "Baptist Memorial Health Care Corporation",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284047.0,
    "level_1": "Emory Healthcare",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284050.0,
    "level_1": "Scripps",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284051.0,
    "level_1": "University Hospital Cleveland Medical Center",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284052.0,
    "level_1": "University Of Rochester Medical Center",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284053.0,
    "level_1": "University Of Virginia Health",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284054.0,
    "level_1": "Vcu Health",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284060.0,
    "level_1": "University Of Colorado Health",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284064.0,
    "level_1": "Emory Healthcare",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284065.0,
    "level_1": "University Of Cincinnati Health",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284071.0,
    "level_1": "University Of California Davis",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284073.0,
    "level_1": "Allegheny Health",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284076.0,
    "level_1": "Froedtert Health",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284079.0,
    "level_1": "Baptist Memorial Health Care Corporation",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284080.0,
    "level_1": "Scripps",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284085.0,
    "level_1": "Providence Credena",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284087.0,
    "level_1": "University Of Colorado Health",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284089.0,
    "level_1": "Kansas University",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284095.0,
    "level_1": "University Of Iowa Health",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284099.0,
    "level_1": "University Of Illinois Chicago",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284100.0,
    "level_1": "University Of Illinois Chicago",
    "level_2": "Hub Engaged",
    "level_3": "Filled",
    "level_4": "Pap",
    "time": 16.0
  },
  {
    "du_patient_id": 10284110.0,
    "level_1": "Froedtert Health",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284111.0,
    "level_1": "Penn State",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284113.0,
    "level_1": "Kansas University",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284125.0,
    "level_1": "Kansas University",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284132.0,
    "level_1": "Baptist Memorial Health Care Corporation",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284134.0,
    "level_1": "University Of Virginia Health",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284136.0,
    "level_1": "University Hospital Cleveland Medical Center",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284138.0,
    "level_1": "Froedtert Health",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284140.0,
    "level_1": "Kansas University",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284147.0,
    "level_1": "Community Health Network Indiana",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284149.0,
    "level_1": "University Of Illinois Chicago",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284165.0,
    "level_1": "Froedtert Health",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284167.0,
    "level_1": "Emory Healthcare",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284168.0,
    "level_1": "Vcu Health",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284172.0,
    "level_1": "Froedtert Health",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284176.0,
    "level_1": "Kansas University",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284178.0,
    "level_1": "Kansas University",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284179.0,
    "level_1": "University Hospital Cleveland Medical Center",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284181.0,
    "level_1": "Baptist Memorial Health Care Corporation",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284187.0,
    "level_1": "Vcu Health",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284189.0,
    "level_1": "University Of California San Francisco",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284196.0,
    "level_1": "Tufts Medical Center",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284198.0,
    "level_1": "Froedtert Health",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284202.0,
    "level_1": "University Of Illinois Chicago",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284212.0,
    "level_1": "Scripps",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284218.0,
    "level_1": "University Of California San Francisco",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284220.0,
    "level_1": "Froedtert Health",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284226.0,
    "level_1": "University Of Virginia Health",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284235.0,
    "level_1": "Froedtert Health",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284237.0,
    "level_1": "Emory Healthcare",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284239.0,
    "level_1": "University Of California San Diego",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284261.0,
    "level_1": "University Of California San Francisco",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284264.0,
    "level_1": "Penn State",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284265.0,
    "level_1": "Emory Healthcare",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284270.0,
    "level_1": "University Of Iowa Health",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284273.0,
    "level_1": "University Of Cincinnati Health",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284275.0,
    "level_1": "University Of Illinois Chicago",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284287.0,
    "level_1": "University Of California San Francisco",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284289.0,
    "level_1": "Emory Healthcare",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284291.0,
    "level_1": "Kansas University",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284298.0,
    "level_1": "Emory Healthcare",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284309.0,
    "level_1": "University Of California San Francisco",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284310.0,
    "level_1": "University Of Cincinnati Health",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284316.0,
    "level_1": "Froedtert Health",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284320.0,
    "level_1": "Emory Healthcare",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284321.0,
    "level_1": "University Of California San Francisco",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284342.0,
    "level_1": "Vcu Health",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284343.0,
    "level_1": "Froedtert Health",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284344.0,
    "level_1": "Froedtert Health",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284348.0,
    "level_1": "Emory Healthcare",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284355.0,
    "level_1": "Kansas University",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284358.0,
    "level_1": "Kansas University",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284359.0,
    "level_1": "University Of California Davis",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284363.0,
    "level_1": "University Of Colorado Health",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284364.0,
    "level_1": "Kansas University",
    "level_2": "Hub Engaged",
    "level_3": "Filled",
    "level_4": "Pap",
    "time": 14.0
  },
  {
    "du_patient_id": 10284367.0,
    "level_1": "Emory Healthcare",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284369.0,
    "level_1": "Baptist Memorial Health Care Corporation",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284372.0,
    "level_1": "Kansas University",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284374.0,
    "level_1": "University Of Colorado Health",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284378.0,
    "level_1": "University Hospital Cleveland Medical Center",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284381.0,
    "level_1": "University Of Iowa Health",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10000846.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10000856.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10000865.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10000916.0,
    "level_1": "Onco360",
    "level_2": "Hub Engaged",
    "level_3": "Filled",
    "level_4": "Paid Claims",
    "time": 5.0
  },
  {
    "du_patient_id": 10000928.0,
    "level_1": "Amber",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10000932.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10000947.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10000959.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10000961.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10000971.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10000978.0,
    "level_1": "Biologics",
    "level_2": "Hub Engaged",
    "level_3": "Filled",
    "level_4": "Bridge/Qs",
    "time": 12.0
  },
  {
    "du_patient_id": 10000982.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10000983.0,
    "level_1": "Onco360",
    "level_2": "Hub Engaged",
    "level_3": null,
    "level_4": "Pending",
    "time": 0.0
  },
  {
    "du_patient_id": 10000984.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10000987.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10000988.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10000989.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10000991.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10000992.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10000993.0,
    "level_1": "Onco360",
    "level_2": "Hub Engaged",
    "level_3": "Filled",
    "level_4": "Pap",
    "time": 11.0
  },
  {
    "du_patient_id": 10000995.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10000997.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10000998.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10000999.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10001000.0,
    "level_1": "Onco360",
    "level_2": "Hub Engaged",
    "level_3": "Filled",
    "level_4": "Pap",
    "time": 2.0
  },
  {
    "du_patient_id": 10001001.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10001002.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10001003.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10001006.0,
    "level_1": "Amber",
    "level_2": "Hub Engaged",
    "level_3": "Filled",
    "level_4": "Pap",
    "time": 35.0
  },
  {
    "du_patient_id": 10001007.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10001044.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10001056.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10001058.0,
    "level_1": "Onco360",
    "level_2": "Hub Engaged",
    "level_3": "Filled",
    "level_4": "Pap",
    "time": 4.0
  },
  {
    "du_patient_id": 10001069.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10001078.0,
    "level_1": "Onco360",
    "level_2": "Hub Engaged",
    "level_3": null,
    "level_4": "Pending",
    "time": 65.0
  },
  {
    "du_patient_id": 10001085.0,
    "level_1": "Onco360",
    "level_2": "Hub Engaged",
    "level_3": "Filled",
    "level_4": "Pap",
    "time": 3.0
  },
  {
    "du_patient_id": 10001097.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10001113.0,
    "level_1": "Amber",
    "level_2": "Hub Engaged",
    "level_3": null,
    "level_4": "Pending",
    "time": 25.0
  },
  {
    "du_patient_id": 10001115.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10001124.0,
    "level_1": "Onco360",
    "level_2": "Hub Engaged",
    "level_3": "Filled",
    "level_4": "Paid Claims",
    "time": 8.0
  },
  {
    "du_patient_id": 10001143.0,
    "level_1": "Onco360",
    "level_2": "Hub Engaged",
    "level_3": "Filled",
    "level_4": "Pap",
    "time": 20.0
  },
  {
    "du_patient_id": 10001144.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10001147.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10001203.0,
    "level_1": "Amber",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10001226.0,
    "level_1": "Amber",
    "level_2": "Hub Engaged",
    "level_3": "Filled",
    "level_4": "Pap",
    "time": 13.0
  },
  {
    "du_patient_id": 10001234.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10001260.0,
    "level_1": "Onco360",
    "level_2": "Hub Engaged",
    "level_3": "Filled",
    "level_4": "Pap",
    "time": 59.0
  },
  {
    "du_patient_id": 10001278.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10001343.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10001362.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10001408.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10001443.0,
    "level_1": "Onco360",
    "level_2": "Hub Engaged",
    "level_3": null,
    "level_4": "Pending",
    "time": 0.0
  },
  {
    "du_patient_id": 10001447.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10001512.0,
    "level_1": "Amber",
    "level_2": "Hub Engaged",
    "level_3": "Filled",
    "level_4": "Paid Claims",
    "time": 8.0
  },
  {
    "du_patient_id": 10001602.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10001629.0,
    "level_1": "Onco360",
    "level_2": "Hub Engaged",
    "level_3": "Filled",
    "level_4": "Pap",
    "time": 22.0
  },
  {
    "du_patient_id": 10001642.0,
    "level_1": "Amber",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10001677.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10001689.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10001740.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10001755.0,
    "level_1": "Biologics",
    "level_2": "Hub Engaged",
    "level_3": "Filled",
    "level_4": "Pap",
    "time": 37.0
  },
  {
    "du_patient_id": 10001758.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10001813.0,
    "level_1": "Onco360",
    "level_2": "Hub Engaged",
    "level_3": "Filled",
    "level_4": "Pap",
    "time": 33.0
  },
  {
    "du_patient_id": 10001830.0,
    "level_1": "Biologics",
    "level_2": "Hub Engaged",
    "level_3": "Filled",
    "level_4": "Pap",
    "time": 11.0
  },
  {
    "du_patient_id": 10001832.0,
    "level_1": "Amber",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10001912.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10001939.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10001946.0,
    "level_1": "Biologics",
    "level_2": "Hub Engaged",
    "level_3": "Filled",
    "level_4": "Pap",
    "time": 3.0
  },
  {
    "du_patient_id": 10002010.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10002028.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10002040.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10002061.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10002073.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10002147.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10002160.0,
    "level_1": "Tulane",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10002186.0,
    "level_1": "Amber",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10002218.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10002237.0,
    "level_1": "Amber",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10002285.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10002296.0,
    "level_1": "Onco360",
    "level_2": "Hub Engaged",
    "level_3": "Filled",
    "level_4": "Pap",
    "time": 10.0
  },
  {
    "du_patient_id": 10002310.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10002339.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10002382.0,
    "level_1": "Biologics",
    "level_2": "Hub Engaged",
    "level_3": null,
    "level_4": "Cancelled At Hub",
    "time": 2.0
  },
  {
    "du_patient_id": 10002415.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10002461.0,
    "level_1": "Amber",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10002473.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10002537.0,
    "level_1": "Baptist Memorial Health Care Corporation",
    "level_2": "Hub Engaged",
    "level_3": "Filled",
    "level_4": "Bridge/Qs",
    "time": 4.0
  },
  {
    "du_patient_id": 10002539.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10002646.0,
    "level_1": "Onco360",
    "level_2": "Hub Engaged",
    "level_3": "Filled",
    "level_4": "Pap",
    "time": 32.0
  },
  {
    "du_patient_id": 10002707.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10002750.0,
    "level_1": "Amber",
    "level_2": "Hub Engaged",
    "level_3": "Filled",
    "level_4": "Pap",
    "time": 6.0
  },
  {
    "du_patient_id": 10002786.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10002788.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10002795.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10002830.0,
    "level_1": "Amber",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10002839.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10002910.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10002923.0,
    "level_1": "Onco360",
    "level_2": "Hub Engaged",
    "level_3": "Filled",
    "level_4": "Pap",
    "time": 1.0
  },
  {
    "du_patient_id": 10002951.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10002955.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10002965.0,
    "level_1": "Biologics",
    "level_2": "Hub Engaged",
    "level_3": null,
    "level_4": "Pending",
    "time": 0.0
  },
  {
    "du_patient_id": 10002990.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10003017.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10003019.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10003031.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10003102.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10003124.0,
    "level_1": "Onco360",
    "level_2": "Hub Engaged",
    "level_3": null,
    "level_4": "Pending",
    "time": 0.0
  },
  {
    "du_patient_id": 10003129.0,
    "level_1": "Onco360",
    "level_2": "Hub Engaged",
    "level_3": "Filled",
    "level_4": "Bridge/Qs",
    "time": 13.0
  },
  {
    "du_patient_id": 10003144.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10003282.0,
    "level_1": "Onco360",
    "level_2": "Hub Engaged",
    "level_3": "Filled",
    "level_4": "Paid Claims",
    "time": 361.0
  },
  {
    "du_patient_id": 10003297.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10003401.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10003422.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10003447.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10003491.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10003514.0,
    "level_1": "Froedtert Health",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10003555.0,
    "level_1": "Onco360",
    "level_2": "Hub Engaged",
    "level_3": "Filled",
    "level_4": "Pap",
    "time": 14.0
  },
  {
    "du_patient_id": 10003565.0,
    "level_1": "University Hospital Cleveland Medical Center",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10003573.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10003605.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10003635.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10003643.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10003663.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10003668.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10003679.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10003688.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10003696.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10003709.0,
    "level_1": "Amber",
    "level_2": "Hub Engaged",
    "level_3": "Filled",
    "level_4": "Bridge/Qs",
    "time": 6.0
  },
  {
    "du_patient_id": 10003726.0,
    "level_1": "Biologics",
    "level_2": "Hub Engaged",
    "level_3": "Filled",
    "level_4": "Pap",
    "time": 29.0
  },
  {
    "du_patient_id": 10003733.0,
    "level_1": "Amber",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10003747.0,
    "level_1": "Onco360",
    "level_2": "Hub Engaged",
    "level_3": "Filled",
    "level_4": "Paid Claims",
    "time": 6.0
  },
  {
    "du_patient_id": 10003780.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10003859.0,
    "level_1": "Biologics",
    "level_2": "Hub Engaged",
    "level_3": "Filled",
    "level_4": "Paid Claims",
    "time": 9.0
  },
  {
    "du_patient_id": 10003866.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10003903.0,
    "level_1": "Onco360",
    "level_2": "Hub Engaged",
    "level_3": "Filled",
    "level_4": "Paid Claims",
    "time": 5.0
  },
  {
    "du_patient_id": 10003971.0,
    "level_1": "Biologics",
    "level_2": "Hub Engaged",
    "level_3": "Filled",
    "level_4": "Pap",
    "time": 11.0
  },
  {
    "du_patient_id": 10004039.0,
    "level_1": "Biologics",
    "level_2": "Hub Engaged",
    "level_3": "Filled",
    "level_4": "Paid Claims",
    "time": 21.0
  },
  {
    "du_patient_id": 10004044.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10004139.0,
    "level_1": "Biologics",
    "level_2": "Hub Engaged",
    "level_3": null,
    "level_4": "Pending",
    "time": 0.0
  },
  {
    "du_patient_id": 10004142.0,
    "level_1": "Onco360",
    "level_2": "Hub Engaged",
    "level_3": "Filled",
    "level_4": "Pap",
    "time": 2.0
  },
  {
    "du_patient_id": 10004160.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10004182.0,
    "level_1": "Onco360",
    "level_2": "Hub Engaged",
    "level_3": "Filled",
    "level_4": "Paid Claims",
    "time": 34.0
  },
  {
    "du_patient_id": 10004298.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10004333.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10004341.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10004350.0,
    "level_1": "University Of Virginia Health",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10004373.0,
    "level_1": "Froedtert Health",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10004389.0,
    "level_1": "Amber",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10004415.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10004490.0,
    "level_1": "Onco360",
    "level_2": "Hub Engaged",
    "level_3": "Filled",
    "level_4": "Bridge/Qs",
    "time": 5.0
  },
  {
    "du_patient_id": 10004502.0,
    "level_1": "Biologics",
    "level_2": "Hub Engaged",
    "level_3": "Filled",
    "level_4": "Pap",
    "time": 33.0
  },
  {
    "du_patient_id": 10004514.0,
    "level_1": "Amber",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10004520.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10004521.0,
    "level_1": "Biologics",
    "level_2": "Hub Engaged",
    "level_3": "Filled",
    "level_4": "Paid Claims",
    "time": 22.0
  },
  {
    "du_patient_id": 10004539.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10004553.0,
    "level_1": "Onco360",
    "level_2": "Hub Engaged",
    "level_3": "Filled",
    "level_4": "Pap",
    "time": 30.0
  },
  {
    "du_patient_id": 10004606.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10004609.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10004631.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10004646.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10004685.0,
    "level_1": "Amber",
    "level_2": "Hub Engaged",
    "level_3": "Filled",
    "level_4": "Pap",
    "time": 23.0
  },
  {
    "du_patient_id": 10004686.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10004708.0,
    "level_1": "Onco360",
    "level_2": "Hub Engaged",
    "level_3": "Filled",
    "level_4": "Pap",
    "time": 32.0
  },
  {
    "du_patient_id": 10004746.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10004750.0,
    "level_1": "Biologics",
    "level_2": "Hub Engaged",
    "level_3": "Filled",
    "level_4": "Paid Claims",
    "time": 30.0
  },
  {
    "du_patient_id": 10004752.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10004791.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10004800.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10004855.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10004864.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10004876.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10004886.0,
    "level_1": "Baptist Memorial Health Care Corporation",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10004895.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10004923.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10004947.0,
    "level_1": "Amber",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10004966.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10004977.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10005038.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10005057.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10005058.0,
    "level_1": "University Of Virginia Health",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10005106.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10005133.0,
    "level_1": "Onco360",
    "level_2": "Hub Engaged",
    "level_3": "Filled",
    "level_4": "Pap",
    "time": 24.0
  },
  {
    "du_patient_id": 10005320.0,
    "level_1": "Amber",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10005353.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10005425.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10005563.0,
    "level_1": "Amber",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10005595.0,
    "level_1": "Amber",
    "level_2": "Hub Engaged",
    "level_3": "Filled",
    "level_4": "Pap",
    "time": 2.0
  },
  {
    "du_patient_id": 10005654.0,
    "level_1": "Amber",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10005672.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10005725.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10005840.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10005881.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10005915.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10005924.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10005967.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10005993.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10006004.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10006073.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10006085.0,
    "level_1": "Onco360",
    "level_2": "Hub Engaged",
    "level_3": "Filled",
    "level_4": "Paid Claims",
    "time": 3.0
  },
  {
    "du_patient_id": 10006177.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10006190.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10006270.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10006296.0,
    "level_1": "Univ Of Arkansas Med Sci",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10006306.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10006331.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10006356.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10006360.0,
    "level_1": "Biologics",
    "level_2": "Hub Engaged",
    "level_3": "Filled",
    "level_4": "Pap",
    "time": 6.0
  },
  {
    "du_patient_id": 10006511.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10006531.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10006594.0,
    "level_1": "Biologics",
    "level_2": "Hub Engaged",
    "level_3": "Filled",
    "level_4": "Pap",
    "time": 36.0
  },
  {
    "du_patient_id": 10006660.0,
    "level_1": "Emory Healthcare",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10006728.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10006756.0,
    "level_1": "Amber",
    "level_2": "Hub Engaged",
    "level_3": "Filled",
    "level_4": "Pap",
    "time": 7.0
  },
  {
    "du_patient_id": 10006767.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10006839.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10006851.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10006900.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10006943.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10007078.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10007100.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10007109.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10007169.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10007172.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10007282.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10007331.0,
    "level_1": "Amber",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10007408.0,
    "level_1": "Amber",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10007431.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10007604.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10007620.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10007655.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10007669.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10007686.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10007892.0,
    "level_1": "Biologics",
    "level_2": "Hub Engaged",
    "level_3": null,
    "level_4": "Pending",
    "time": 1.0
  },
  {
    "du_patient_id": 10007913.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10007920.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10007983.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10008173.0,
    "level_1": "Amber",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10008275.0,
    "level_1": "Biologics",
    "level_2": "Hub Engaged",
    "level_3": "Filled",
    "level_4": "Pap",
    "time": 8.0
  },
  {
    "du_patient_id": 10008286.0,
    "level_1": "Baptist Memorial Health Care Corporation",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10008318.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10008380.0,
    "level_1": "Onco360",
    "level_2": "Hub Engaged",
    "level_3": null,
    "level_4": "Pending",
    "time": 3.0
  },
  {
    "du_patient_id": 10008470.0,
    "level_1": "Amber",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10008537.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10008577.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10008596.0,
    "level_1": "Onco360",
    "level_2": "Hub Engaged",
    "level_3": null,
    "level_4": "Pending",
    "time": 0.0
  },
  {
    "du_patient_id": 10008687.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10008705.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10008805.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10008811.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10008817.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10008992.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10009024.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10009165.0,
    "level_1": "Amber",
    "level_2": "Hub Engaged",
    "level_3": null,
    "level_4": "Cancelled At Hub",
    "time": 15.0
  },
  {
    "du_patient_id": 10009177.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10009206.0,
    "level_1": "Baptist Memorial Health Care Corporation",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10009212.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10009216.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10009223.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10009282.0,
    "level_1": "Onco360",
    "level_2": "Hub Engaged",
    "level_3": "Filled",
    "level_4": "Paid Claims",
    "time": 8.0
  },
  {
    "du_patient_id": 10009378.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10009407.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10009426.0,
    "level_1": "Amber",
    "level_2": "Hub Engaged",
    "level_3": "Filled",
    "level_4": "Paid Claims",
    "time": 1.0
  },
  {
    "du_patient_id": 10009448.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10009564.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10009566.0,
    "level_1": "Vcu Health",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10009588.0,
    "level_1": "Amber",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10009639.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10009719.0,
    "level_1": "Amber",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10009753.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10009773.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10009871.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10010021.0,
    "level_1": "Baptist Memorial Health Care Corporation",
    "level_2": "Hub Engaged",
    "level_3": null,
    "level_4": "Pending",
    "time": 67.0
  },
  {
    "du_patient_id": 10010022.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10010025.0,
    "level_1": "Amber",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10010033.0,
    "level_1": "Amber",
    "level_2": "Hub Engaged",
    "level_3": "Filled",
    "level_4": "Pap",
    "time": 227.0
  },
  {
    "du_patient_id": 10010085.0,
    "level_1": "Amber",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10010150.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10010217.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10010241.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10010263.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10010292.0,
    "level_1": "Amber",
    "level_2": "Hub Engaged",
    "level_3": "Filled",
    "level_4": "Paid Claims",
    "time": 494.0
  },
  {
    "du_patient_id": 10010294.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10010323.0,
    "level_1": "Amber",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10010333.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10010412.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10010441.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10010526.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10010612.0,
    "level_1": "University Of Cincinnati Health",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10010672.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10010698.0,
    "level_1": "Biologics",
    "level_2": "Hub Engaged",
    "level_3": "Filled",
    "level_4": "Pap",
    "time": 4.0
  },
  {
    "du_patient_id": 10010706.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10010746.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10010779.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10010783.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10010901.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10010921.0,
    "level_1": "Onco360",
    "level_2": "Hub Engaged",
    "level_3": null,
    "level_4": "Pending",
    "time": 82.0
  },
  {
    "du_patient_id": 10010980.0,
    "level_1": "Onco360",
    "level_2": "Hub Engaged",
    "level_3": "Filled",
    "level_4": "Pap",
    "time": 13.0
  },
  {
    "du_patient_id": 10011008.0,
    "level_1": "Amber",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10011018.0,
    "level_1": "Onco360",
    "level_2": "Hub Engaged",
    "level_3": "Filled",
    "level_4": "Pap",
    "time": 22.0
  },
  {
    "du_patient_id": 10011029.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10011056.0,
    "level_1": "Onco360",
    "level_2": "Hub Engaged",
    "level_3": null,
    "level_4": "Pending",
    "time": 0.0
  },
  {
    "du_patient_id": 10011150.0,
    "level_1": "Univ Of Arkansas Med Sci",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10011158.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10011345.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10011444.0,
    "level_1": "Amber",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10011498.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10011511.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10011800.0,
    "level_1": "Biologics",
    "level_2": "Hub Engaged",
    "level_3": "Filled",
    "level_4": "Pap",
    "time": 7.0
  },
  {
    "du_patient_id": 10011848.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10011970.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10011994.0,
    "level_1": "Univ Of Arkansas Med Sci",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10012043.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10012156.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10012352.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10012462.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10012477.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10012479.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10012538.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10012618.0,
    "level_1": "Onco360",
    "level_2": "Hub Engaged",
    "level_3": "Filled",
    "level_4": "Pap",
    "time": 18.0
  },
  {
    "du_patient_id": 10012802.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10012894.0,
    "level_1": "Amber",
    "level_2": "Hub Engaged",
    "level_3": "Filled",
    "level_4": "Paid Claims",
    "time": 30.0
  },
  {
    "du_patient_id": 10013196.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10013210.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10013382.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10013463.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10013545.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10013581.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10013667.0,
    "level_1": "Onco360",
    "level_2": "Hub Engaged",
    "level_3": "Filled",
    "level_4": "Paid Claims",
    "time": 1065.0
  },
  {
    "du_patient_id": 10013804.0,
    "level_1": "Amber",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10013995.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10014006.0,
    "level_1": "Amber",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10014048.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10014240.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10014265.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10014271.0,
    "level_1": "University Of Illinois Chicago",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10014922.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10015340.0,
    "level_1": "Vcu Health",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10015387.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10015521.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10015652.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10015845.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10015903.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10015948.0,
    "level_1": "Amber",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10016095.0,
    "level_1": "Onco360",
    "level_2": "Hub Engaged",
    "level_3": null,
    "level_4": "Pending",
    "time": 145.0
  },
  {
    "du_patient_id": 10016277.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10016511.0,
    "level_1": "Emory Healthcare",
    "level_2": "Hub Engaged",
    "level_3": "Filled",
    "level_4": "Bridge/Qs",
    "time": 4.0
  },
  {
    "du_patient_id": 10016549.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10016639.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10016688.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10017007.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10017044.0,
    "level_1": "Amber",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10017352.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10017480.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10017627.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10017695.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10017899.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10017966.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10018038.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10018091.0,
    "level_1": "Amber",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10018162.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10018348.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10018412.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10018597.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10018827.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10018878.0,
    "level_1": "Froedtert Health",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10018935.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10018953.0,
    "level_1": "Biologics",
    "level_2": "Hub Engaged",
    "level_3": "Filled",
    "level_4": "Paid Claims",
    "time": 7.0
  },
  {
    "du_patient_id": 10018959.0,
    "level_1": "Onco360",
    "level_2": "Hub Engaged",
    "level_3": "Filled",
    "level_4": "Pap",
    "time": 15.0
  },
  {
    "du_patient_id": 10018978.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10018981.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10018997.0,
    "level_1": "Amber",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10019015.0,
    "level_1": "Onco360",
    "level_2": "Hub Engaged",
    "level_3": "Filled",
    "level_4": "Pap",
    "time": 2.0
  },
  {
    "du_patient_id": 10019067.0,
    "level_1": "Onco360",
    "level_2": "Hub Engaged",
    "level_3": "Filled",
    "level_4": "Bridge/Qs",
    "time": 13.0
  },
  {
    "du_patient_id": 10019092.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10019146.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10019147.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10019157.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10019211.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10019286.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10019346.0,
    "level_1": "Amber",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10019365.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10019385.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10019394.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10019398.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10019414.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10019441.0,
    "level_1": "Amber",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10019442.0,
    "level_1": "Amber",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10019445.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10218677.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10218678.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10218905.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10218906.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10219027.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10219117.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10219427.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10219618.0,
    "level_1": "Amber",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10219620.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10219621.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10219960.0,
    "level_1": "Amber",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10219961.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10221111.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10221251.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10221696.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10221699.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10221706.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10221707.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10222163.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10222875.0,
    "level_1": "Amber",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10223168.0,
    "level_1": "Onco360",
    "level_2": "Hub Engaged",
    "level_3": "Filled",
    "level_4": "Paid Claims",
    "time": 18.0
  },
  {
    "du_patient_id": 10229152.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10229594.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10230437.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10230442.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10230795.0,
    "level_1": "Amber",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10230931.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10231289.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10231717.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10231970.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10231971.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10235677.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10235977.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10236069.0,
    "level_1": "Amber",
    "level_2": "Hub Engaged",
    "level_3": null,
    "level_4": "Cancelled At Hub",
    "time": 0.0
  },
  {
    "du_patient_id": 10236070.0,
    "level_1": "Biologics",
    "level_2": "Hub Engaged",
    "level_3": null,
    "level_4": "Cancelled At Hub",
    "time": 7.0
  },
  {
    "du_patient_id": 10236193.0,
    "level_1": "Amber",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10236380.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10236727.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10236861.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10237411.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10237413.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10237534.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10237620.0,
    "level_1": "Onco360",
    "level_2": "Hub Engaged",
    "level_3": "Filled",
    "level_4": "Paid Claims",
    "time": 35.0
  },
  {
    "du_patient_id": 10238123.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10238385.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10238537.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10238815.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10243627.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10244472.0,
    "level_1": "Amber",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10244819.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10245111.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10245448.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10246620.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10246623.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10247133.0,
    "level_1": "Onco360",
    "level_2": "Hub Engaged",
    "level_3": "Filled",
    "level_4": "Pap",
    "time": 4.0
  },
  {
    "du_patient_id": 10247807.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10247810.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10248140.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10248983.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10249108.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10249162.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10249163.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10249406.0,
    "level_1": "Onco360",
    "level_2": "Hub Engaged",
    "level_3": "Filled",
    "level_4": "Pap",
    "time": 2.0
  },
  {
    "du_patient_id": 10249650.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10250083.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10250550.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10250552.0,
    "level_1": "Baptist Memorial Health Care Corporation",
    "level_2": "Hub Engaged",
    "level_3": "Filled",
    "level_4": "Paid Claims",
    "time": 8.0
  },
  {
    "du_patient_id": 10250582.0,
    "level_1": "Univ Of Arkansas Med Sci",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10250741.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10250742.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10250930.0,
    "level_1": "Biologics",
    "level_2": "Hub Engaged",
    "level_3": null,
    "level_4": "Pending",
    "time": 0.0
  },
  {
    "du_patient_id": 10252297.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10252559.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10252862.0,
    "level_1": "Vcu Health",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10253110.0,
    "level_1": "Onco360",
    "level_2": "Hub Engaged",
    "level_3": null,
    "level_4": "Cancelled At Hub",
    "time": 0.0
  },
  {
    "du_patient_id": 10253272.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10253273.0,
    "level_1": "University Hospital Cleveland Medical Center",
    "level_2": "Hub Engaged",
    "level_3": "Filled",
    "level_4": "Pap",
    "time": 4.0
  },
  {
    "du_patient_id": 10253567.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10254230.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10254233.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10254711.0,
    "level_1": "Biologics",
    "level_2": "Hub Engaged",
    "level_3": "Filled",
    "level_4": "Paid Claims",
    "time": 21.0
  },
  {
    "du_patient_id": 10254712.0,
    "level_1": "Amber",
    "level_2": "Hub Engaged",
    "level_3": "Filled",
    "level_4": "Paid Claims",
    "time": 44.0
  },
  {
    "du_patient_id": 10255383.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10255384.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10255748.0,
    "level_1": "Tulane",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10256069.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10256071.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10256802.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10256803.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10256805.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10259909.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10260698.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10260860.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10260862.0,
    "level_1": "Onco360",
    "level_2": "Hub Engaged",
    "level_3": null,
    "level_4": "Pending",
    "time": 0.0
  },
  {
    "du_patient_id": 10261105.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10261489.0,
    "level_1": "Froedtert Health",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10261494.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10262177.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10262178.0,
    "level_1": "Amber",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10262472.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10262818.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10262819.0,
    "level_1": "Amber",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10263036.0,
    "level_1": "University Of Rochester Medical Center",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10264594.0,
    "level_1": "Amber",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10264595.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10264895.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10265015.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10265170.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10265339.0,
    "level_1": "Amber",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10265716.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10265931.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10266547.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10266549.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10266626.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10266680.0,
    "level_1": "Biologics",
    "level_2": "Hub Engaged",
    "level_3": "Filled",
    "level_4": "Paid Claims",
    "time": 9.0
  },
  {
    "du_patient_id": 10266859.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10267076.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10267551.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10268533.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10268832.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10269022.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10269197.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10269199.0,
    "level_1": "Amber",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10270041.0,
    "level_1": "Biologics",
    "level_2": "Hub Engaged",
    "level_3": "Filled",
    "level_4": "Paid Claims",
    "time": 39.0
  },
  {
    "du_patient_id": 10284385.0,
    "level_1": "Vcu Health",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284387.0,
    "level_1": "Scripps",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284399.0,
    "level_1": "University Of Virginia Health",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284410.0,
    "level_1": "Baptist Memorial Health Care Corporation",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284413.0,
    "level_1": "Emory Healthcare",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284415.0,
    "level_1": "Penn State",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284417.0,
    "level_1": "Emory Healthcare",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284419.0,
    "level_1": "Froedtert Health",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284420.0,
    "level_1": "Kansas University",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284421.0,
    "level_1": "University Hospital Cleveland Medical Center",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284425.0,
    "level_1": "Kansas University",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284429.0,
    "level_1": "University Of Iowa Health",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284431.0,
    "level_1": "Kansas University",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284438.0,
    "level_1": "Emory Healthcare",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284443.0,
    "level_1": "University Of California San Francisco",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284445.0,
    "level_1": "Scripps",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284446.0,
    "level_1": "University Of California San Francisco",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284449.0,
    "level_1": "Froedtert Health",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284452.0,
    "level_1": "University Of Illinois Chicago",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284453.0,
    "level_1": "Tufts Medical Center",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284459.0,
    "level_1": "Vcu Health",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284463.0,
    "level_1": "University Hospital Cleveland Medical Center",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284468.0,
    "level_1": "University Of California Davis",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284476.0,
    "level_1": "Kansas University",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284477.0,
    "level_1": "University Of Colorado Health",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284479.0,
    "level_1": "Emory Healthcare",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284480.0,
    "level_1": "Penn State",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284484.0,
    "level_1": "Emory Healthcare",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284486.0,
    "level_1": "Froedtert Health",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284500.0,
    "level_1": "Froedtert Health",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284509.0,
    "level_1": "Froedtert Health",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284512.0,
    "level_1": "University Of California San Francisco",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284513.0,
    "level_1": "Kansas University",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284514.0,
    "level_1": "University Of California Davis",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284515.0,
    "level_1": "Emory Healthcare",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284518.0,
    "level_1": "Emory Healthcare",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284521.0,
    "level_1": "Froedtert Health",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284530.0,
    "level_1": "Kansas University",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284533.0,
    "level_1": "Vcu Health",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284541.0,
    "level_1": "University Of Colorado Health",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284542.0,
    "level_1": "Emory Healthcare",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284543.0,
    "level_1": "University Of Illinois Chicago",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284547.0,
    "level_1": "Penn State",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284554.0,
    "level_1": "Baptist Memorial Health Care Corporation",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284558.0,
    "level_1": "University Of Illinois Chicago",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284559.0,
    "level_1": "Emory Healthcare",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284567.0,
    "level_1": "Emory Healthcare",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284593.0,
    "level_1": "Baptist Memorial Health Care Corporation",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284608.0,
    "level_1": "Emory Healthcare",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284609.0,
    "level_1": "University Of California San Francisco",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284616.0,
    "level_1": "University Of Illinois Chicago",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284618.0,
    "level_1": "University Of Colorado Health",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284621.0,
    "level_1": "Baptist Memorial Health Care Corporation",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284734.0,
    "level_1": "Froedtert Health",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10284811.0,
    "level_1": "Amber",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10285071.0,
    "level_1": "University Of California San Francisco",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10285155.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10285453.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10285752.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10285864.0,
    "level_1": "University Of Iowa Health",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10285960.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10286294.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10286922.0,
    "level_1": "Amber",
    "level_2": "Hub Engaged",
    "level_3": "Filled",
    "level_4": "Paid Claims",
    "time": 77.0
  },
  {
    "du_patient_id": 10286923.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10286924.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10287029.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10287127.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10287508.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10287576.0,
    "level_1": "University Of Virginia Health",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10287577.0,
    "level_1": "University Of Cincinnati Health",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10287578.0,
    "level_1": "University Of Iowa Health",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10287657.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10287840.0,
    "level_1": "University Of Rochester Medical Center",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10287856.0,
    "level_1": "University Of Illinois Chicago",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10287860.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10287870.0,
    "level_1": "Froedtert Health",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10288188.0,
    "level_1": "University Of Cincinnati Health",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10288223.0,
    "level_1": "University Of Virginia Health",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10288228.0,
    "level_1": "Froedtert Health",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10288238.0,
    "level_1": "Penn State",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10288242.0,
    "level_1": "University Of California San Francisco",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10288330.0,
    "level_1": "University Of Illinois Chicago",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10288466.0,
    "level_1": "Penn State",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10288556.0,
    "level_1": "University Of Iowa Health",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10288568.0,
    "level_1": "University Of California San Francisco",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10288652.0,
    "level_1": "University Of Illinois Chicago",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10288734.0,
    "level_1": "Emory Healthcare",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10288741.0,
    "level_1": "Penn State",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10289090.0,
    "level_1": "University Of Iowa Health",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10289116.0,
    "level_1": "Emory Healthcare",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10289320.0,
    "level_1": "Onco360",
    "level_2": "Hub Engaged",
    "level_3": "Filled",
    "level_4": "Pap",
    "time": 32.0
  },
  {
    "du_patient_id": 10289474.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10289686.0,
    "level_1": "University Of Iowa Health",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10289689.0,
    "level_1": "University Of Illinois Chicago",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10289690.0,
    "level_1": "University Of Iowa Health",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10289714.0,
    "level_1": "Amber",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10289715.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10290592.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10291237.0,
    "level_1": "Emory Healthcare",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10291239.0,
    "level_1": "Scripps",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10291464.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10291465.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10291569.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10291953.0,
    "level_1": "Amber",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10292025.0,
    "level_1": "University Of California San Francisco",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10292758.0,
    "level_1": "Penn State",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10292843.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10293836.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10294418.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10294675.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10294912.0,
    "level_1": "Froedtert Health",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10295381.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10295692.0,
    "level_1": "Onco360",
    "level_2": "Hub Engaged",
    "level_3": "Filled",
    "level_4": "Pap",
    "time": 17.0
  },
  {
    "du_patient_id": 10296393.0,
    "level_1": "Emory Healthcare",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10296396.0,
    "level_1": "University Of California San Francisco",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10296479.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10296480.0,
    "level_1": "Amber",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10297075.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10297443.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10297713.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10297748.0,
    "level_1": "Emory Healthcare",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10297759.0,
    "level_1": "Kansas University",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10298478.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10298480.0,
    "level_1": "University Hospital Cleveland Medical Center",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10299242.0,
    "level_1": "Emory Healthcare",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10299243.0,
    "level_1": "Emory Healthcare",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10312092.0,
    "level_1": "University Of Iowa Health",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10312095.0,
    "level_1": "Emory Healthcare",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10312189.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10312190.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10312480.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10312626.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10313913.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10313914.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10313915.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10314068.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10314665.0,
    "level_1": "University Of Illinois Chicago",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10314982.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10314983.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10314986.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10316273.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10317265.0,
    "level_1": "Penn State",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10317267.0,
    "level_1": "Univ Of Arkansas Med Sci",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10317268.0,
    "level_1": "Univ Of Arkansas Med Sci",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10317269.0,
    "level_1": "Univ Of Arkansas Med Sci",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10317271.0,
    "level_1": "Univ Of Arkansas Med Sci",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10317272.0,
    "level_1": "Stanford Medical Center A Trade Name For Stanfor Health Care",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10317273.0,
    "level_1": "Penn State",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10317275.0,
    "level_1": "Univ Of Arkansas Med Sci",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10317286.0,
    "level_1": "Univ Of Arkansas Med Sci",
    "level_2": "Hub Engaged",
    "level_3": "Filled",
    "level_4": "Pap",
    "time": 1.0
  },
  {
    "du_patient_id": 10317287.0,
    "level_1": "Univ Of Arkansas Med Sci",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10317292.0,
    "level_1": "Univ Of Arkansas Med Sci",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10317295.0,
    "level_1": "Univ Of Arkansas Med Sci",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10317300.0,
    "level_1": "Univ Of Arkansas Med Sci",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10317961.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10318343.0,
    "level_1": "Univ Of Arkansas Med Sci",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10318344.0,
    "level_1": "Univ Of Arkansas Med Sci",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10318348.0,
    "level_1": "Univ Of Arkansas Med Sci",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10318349.0,
    "level_1": "Stanford Medical Center A Trade Name For Stanfor Health Care",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10318357.0,
    "level_1": "Univ Of Arkansas Med Sci",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10319267.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10319453.0,
    "level_1": "University Of Cincinnati Health",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10319459.0,
    "level_1": "Emory Healthcare",
    "level_2": "Hub Engaged",
    "level_3": null,
    "level_4": "Pending",
    "time": 18.0
  },
  {
    "du_patient_id": 10319470.0,
    "level_1": "University Of Cincinnati Health",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10319573.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10319574.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10319811.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10319812.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10319910.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10319911.0,
    "level_1": "Amber",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10320139.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10320212.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10320318.0,
    "level_1": "Emory Healthcare",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10320349.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10320547.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10321144.0,
    "level_1": "Emory Healthcare",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10330994.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10671936.0,
    "level_1": "Emory Healthcare",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10821553.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10821554.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10988596.0,
    "level_1": "Biologics",
    "level_2": "Hub Engaged",
    "level_3": "Filled",
    "level_4": "Pap",
    "time": 12.0
  },
  {
    "du_patient_id": 10988597.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 10988600.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 11138761.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 11239003.0,
    "level_1": "Amber",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 11239004.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 11339316.0,
    "level_1": "Amber",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 11507274.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 11507278.0,
    "level_1": "Onco360",
    "level_2": "Hub Engaged",
    "level_3": "Filled",
    "level_4": "Paid Claims",
    "time": 11.0
  },
  {
    "du_patient_id": 11758826.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 12011602.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 12011603.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 12216829.0,
    "level_1": "University Of Virginia Health",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 12216831.0,
    "level_1": "University Of Colorado Health",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 12524896.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 12730453.0,
    "level_1": "Emory Healthcare",
    "level_2": "Hub Engaged",
    "level_3": "Filled",
    "level_4": "Pap",
    "time": 30.0
  },
  {
    "du_patient_id": 12730470.0,
    "level_1": "Emory Healthcare",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 12756182.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 12756183.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 12884803.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 12884804.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 12884807.0,
    "level_1": "Uf Shands Gainesville",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 13039262.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 13342620.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 13342621.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 13371440.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 13523152.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 13794258.0,
    "level_1": "University Of Illinois Chicago",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 13823175.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 13924810.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 14027117.0,
    "level_1": "Uf Shands Gainesville",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 14028439.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 14029878.0,
    "level_1": "Emory Healthcare",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 14193580.0,
    "level_1": "Biologics",
    "level_2": "Hub Engaged",
    "level_3": "Filled",
    "level_4": "Pap",
    "time": 7.0
  },
  {
    "du_patient_id": 14222939.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 14355007.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 14428576.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 14635719.0,
    "level_1": "Emory Healthcare",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 14665389.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 14785490.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 14815116.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 15056563.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 15118299.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 15118302.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 15215954.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 15538019.0,
    "level_1": "University Of California San Diego",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 15621404.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 15718881.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 15718886.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 15779240.0,
    "level_1": "University Of Colorado Health",
    "level_2": "Hub Engaged",
    "level_3": "Filled",
    "level_4": "Pap",
    "time": 5.0
  },
  {
    "du_patient_id": 15839739.0,
    "level_1": "Penn State",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 15930592.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 15991122.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 16021574.0,
    "level_1": "Amber",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 16289647.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 16480285.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 16480288.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 16759946.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 16905336.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 16973656.0,
    "level_1": "Emory Healthcare",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 17033873.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 17247683.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 17325105.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 17437069.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 17454412.0,
    "level_1": "Onco360",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  },
  {
    "du_patient_id": 17541080.0,
    "level_1": "Biologics",
    "level_2": "Hub Not Engaged",
    "level_3": null,
    "level_4": null,
    "time": null
  }
]